import { SxProps } from "@mui/material";

export const sxProgressBar: SxProps = {
  height: 24,
  borderRadius: 16,
  backgroundColor: '#00995D',
  '& .MuiLinearProgress-bar': {
    borderRadius: 16,
    backgroundColor: '#FFFFFF',
  }
}